import { WebApiActionPost } from "components/ajax/WebApi";
import rootUrl from "./url";

export interface OznData {
    hostovaniId: number;
    typZpravy: number;
}

export default function (): WebApiActionPost<OznData, {}> {
    return new WebApiActionPost<OznData, {}>(rootUrl + "OznameniHostDlouhodobe");
}
